// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cabth{display:flex;flex-direction:column;gap:16px}.i25W8{width:100%;margin-block-start:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxGroup": `cabth`,
	"searchbox": `i25W8`
};
export default ___CSS_LOADER_EXPORT___;
